import React, { useContext, useState } from 'react';
import { Col, Flex, Row, Switch } from 'antd';

import IBTooltip from '@totem/components/common/helpTooltips/IBTooltip';
import BulkTagButton from '@totem/components/software/software_report/bulkTagButton';
import TagsSection from '@totem/components/software/software_report/byTag/tagsSection';
import CountBadge from '@totem/components/software/software_report/countBadge';
import MergeButton from '@totem/components/software/software_report/mergeButton';
import SoftwareContainer from '@totem/components/software/software_report/softwareContainer';
import SoftwareFilters from '@totem/components/software/software_report/softwareFilters';
import SoftwareTable from '@totem/components/software/software_report/softwareTable';
import SwitchMonitored from '@totem/components/software/software_report/switchMonitored';
import WhereFoundButton from '@totem/components/software/software_report/whereFoundButton';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import { emptyId } from '@totem/components/userContext/security/userUtilities';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';

const styles = {
  inset: {
    marginLeft: '20px',
    marginRight: '20px',
  },
};

const SoftwarePanel = () => {
  const { userProfile } = useContext(UserProfileContext);
  const [grouped, setGrouped] = useState<boolean>(false);
  return (
    <SoftwareContainer organizationId={emptyId}>
      <IBCard isCovered>
        <SoftwareFilters />
        <br />
        <br />
        <div style={styles.inset}>
          <Row>
            <Col span={12}>
              <Flex justify={'flex-start'} align={'center'}>
                {permissions.internalSystemAdministrator.hasPermissions(
                  userProfile,
                ) && (
                  <>
                    <IBTooltip
                      content={permissions.internalSystemAdministrator.tooltip}
                    >
                      <MergeButton />
                    </IBTooltip>
                    <IBTooltip
                      content={permissions.internalSystemAdministrator.tooltip}
                    >
                      <BulkTagButton isPrimary />
                    </IBTooltip>
                  </>
                )}
                {permissions.internal.hasPermissions(userProfile) && (
                  <WhereFoundButton />
                )}
              </Flex>
            </Col>
            <Col span={12}>
              <Flex justify={'flex-end'} align={'center'}>
                <SwitchMonitored />
                Group by Tag:
                <Switch
                  style={{ marginRight: '16px', marginLeft: '8px' }}
                  onChange={setGrouped}
                  value={grouped}
                />
                <CountBadge />
              </Flex>
            </Col>
          </Row>
          <br />
          {!grouped && <SoftwareTable />}
          {grouped && <TagsSection />}
        </div>
      </IBCard>
    </SoftwareContainer>
  );
};

export default SoftwarePanel;
